import { render, staticRenderFns } from "./DashboardSettings.vue?vue&type=template&id=590e3d1a"
import script from "./DashboardSettings.vue?vue&type=script&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports